export const logo =
  "https://ourrecipes.in/wp-content/uploads/2021/09/our-recipes-logo-retina.png";

export const API_URL = "https://forkify-api.herokuapp.com/api";
